import * as Yup from 'yup';

export const setItemValidation = Yup.object().shape({
    setItem: Yup.array().of(
        Yup.object().shape({
            product_id: Yup.string().required(),
            wholesales_price: Yup.number().required("wholesales price is required"),
            distributor_price: Yup.number().required("distributor price is required"),
            factory_price: Yup.number().required("factory price is required"),
            online_price: Yup.number().required("online price is required"),
            special_arrangement_price: Yup.number().required(),
            price_retail: Yup.number().required("price retail is required"),
        })
    )
})

export type SetItemPriceFormType = Yup.InferType<typeof setItemValidation>